import { Outlet } from 'react-router-dom';
import { Upload, List } from 'lucide-react';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { t } from '@lingui/core/macro';

export function FilesLayout() {
  const items: MenuItemsType[] = [
    {
      label: t`Upload`,
      link: `/developer-tools/files/upload`,
      icon: Upload,
    },
    {
      label: t`List`,
      link: `/developer-tools/files/list`,
      icon: List,
    },
  ];

  return (
    <SidebarLayout items={items} label={t`Files Service`} showCollapseButton={false}>
      <Outlet />
    </SidebarLayout>
  );
}
